<template>
    <v-flex class="pagina-curso" xs12 fill-height>
        <nav-buttons-app :mod="mod" @changeTransition="newTranstion"></nav-buttons-app>
        <div class="contenido">
            <transition name="fade">
                <component :is="'mod' + $route.params.unipage + '-app'"></component>
            </transition>
        </div>
    </v-flex>
</template>
<script>
    import mod0 from "./mod0";
    import mod1 from "./mod1";
    import mod2 from "./mod2";

    export default {
        components: {
            "mod0-app": mod0,
            "mod1-app": mod1,
            "mod2-app": mod2,

        },
        data() {
            return {
                noOfPages: 3,
                mod: {
                    modurl: "presentacion"
                },
                verdialogo:0,
                nameTransition:[
                    'content-scroll',
                    'content-scroll-B'
                ],
                valTransition:0
            };
        },        
        computed: {
            currentPage() {
              return Math.floor(this.$route.params.unipage);
            },
            subModName() {
                return this.$store.state.subTema;
            },
        },
        methods: {
            newTranstion(num){
                this.valTransition = num
                console.log('this.valTransition '+this.valTransition)
            }
        },
        // mounted y updated: Carga el número de pantallas en el store para que las flechas de navegación funcionen
        mounted() {
            this.$store.commit("screenTrack", [this.currentPage, this.noOfPages]);
        },
        updated() {
            this.$store.commit("screenTrack", [this.currentPage, this.noOfPages]);   
        }
        
    };
</script>
<style lang="scss">
// NOT SCOPED !!
@import "../../sass/globals";

    .pagina-curso {
        background-image: url("../../assets/fondo/Hoja_Izquierda_Optima.svg");
        background-repeat: no-repeat;
        background-position: bottom left;
        background-size: 180px;
        height: 100vh;
        overflow-y: auto;
        transition: all 0.3s ease-in-out;

        .contenido {
            max-width: 100%;
            width: 1100px;
            margin: auto;
            position: relative;
            overflow: hidden;
            min-height: calc(100vh - 60px);
            height: auto;
            padding: 10px;
            margin-top: 10px;
        }
}

.fade-enter-active, .fade-leave-active {
      transition: all 2s;
    position: absolute;
    max-height: 100%;
    min-height: 100%;
    max-width: calc(100% - 20px);
    min-width: calc(100% - 20px);
    overflow: hidden;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
